import { ppdLagoon } from '@sde/core/src/tools/lagoon/ppdLagoon';

const getMessage = (id, data) => {
  const { uiMessages } = ppdLagoon;
  const { errorMessages } = ppdLagoon;
  let message;

  if (uiMessages) {
    message = uiMessages[id];
  }

  // If message not found in ui-messages table, search in error-messages
  if (!message && errorMessages) {
    message = errorMessages[id];
  }

  if (data && /{{[a-zA-Z0-9_]+}}/.test(message)) {
    const messageMatches = message.match(/{{([a-zA-Z0-9_]+)}}/g);

    for (let i = 0; i < messageMatches.length; i++) {
      const match = messageMatches[i];
      const dataMatch = match.replace('{{', '').replace('}}', '');
      message = message.replace(match, data[dataMatch] || '');
    }
  }
  return message;
};

export { getMessage };
